import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efea7306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row principle_transactions mt-4 px-3 w-100" }
const _hoisted_2 = { class: "col-md-12 table-responsive" }
const _hoisted_3 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date Invested"),
    /*#__PURE__*/_createElementVNode("th", null, "Invested Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Principle Amt Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Principle Balance"),
    /*#__PURE__*/_createElementVNode("th", null, "Maturity Date")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "main_securities"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No records found")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row myinvestment_transactions mt-4 px-3 w-100" }
const _hoisted_9 = { class: "col-md-12 table-responsive" }
const _hoisted_10 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"110px"} }, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"135px"} }, "Credit"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"135px"} }, "Debit")
  ])
], -1))
const _hoisted_12 = { class: "desc_td" }
const _hoisted_13 = { style: {"min-width":"135px"} }
const _hoisted_14 = { style: {"min-width":"135px"} }
const _hoisted_15 = {
  key: 0,
  class: "main_securities"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No records found")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { myinv_id: _ctx.myinv_id }, null, 8, ["myinv_id"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principles, (principle) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: principle.trans_id,
                class: "main_securities"
              }, [
                _createElementVNode("td", null, _toDisplayString(principle.principle_start_date), 1),
                _createElementVNode("td", null, _toDisplayString(principle.principle_invested_amount), 1),
                _createElementVNode("td", null, _toDisplayString(principle.principle_paid_amount), 1),
                _createElementVNode("td", null, _toDisplayString(principle.principle_amount), 1),
                _createElementVNode("td", null, _toDisplayString(principle.maturity_date), 1)
              ]))
            }), 128)),
            (!_ctx.principles.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (trans) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "main_securities",
                key: trans.trans_id
              }, [
                _createElementVNode("td", null, _toDisplayString(trans.trans_date), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(trans.ref_description), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(trans.trans_credit), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(trans.trans_debit), 1)
              ]))
            }), 128)),
            (!_ctx.transactions.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}